/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { FxIdDomainSettingsFxEventsClientPublicConfig } from './FxIdDomainSettingsFxEventsClientPublicConfig';
import {
    instanceOfFxIdDomainSettingsFxEventsClientPublicConfig,
    FxIdDomainSettingsFxEventsClientPublicConfigFromJSON,
    FxIdDomainSettingsFxEventsClientPublicConfigFromJSONTyped,
    FxIdDomainSettingsFxEventsClientPublicConfigToJSON,
} from './FxIdDomainSettingsFxEventsClientPublicConfig';

/**
 * @type FxIdDomainSettingsPublicWebClientConfigOptionsFxEvents
 * Настройки для FxEvents - смотри README
 * @export
 */
export type FxIdDomainSettingsPublicWebClientConfigOptionsFxEvents = FxIdDomainSettingsFxEventsClientPublicConfig;

export function FxIdDomainSettingsPublicWebClientConfigOptionsFxEventsFromJSON(json: any): FxIdDomainSettingsPublicWebClientConfigOptionsFxEvents {
    return FxIdDomainSettingsPublicWebClientConfigOptionsFxEventsFromJSONTyped(json, false);
}

export function FxIdDomainSettingsPublicWebClientConfigOptionsFxEventsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdDomainSettingsPublicWebClientConfigOptionsFxEvents {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdDomainSettingsFxEventsClientPublicConfig(json)) {
        return FxIdDomainSettingsFxEventsClientPublicConfigFromJSONTyped(json, true);
    }

    return {} as any;
}

export function FxIdDomainSettingsPublicWebClientConfigOptionsFxEventsToJSON(json: any): any {
    return FxIdDomainSettingsPublicWebClientConfigOptionsFxEventsToJSONTyped(json, false);
}

export function FxIdDomainSettingsPublicWebClientConfigOptionsFxEventsToJSONTyped(value?: FxIdDomainSettingsPublicWebClientConfigOptionsFxEvents | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    if (instanceOfFxIdDomainSettingsFxEventsClientPublicConfig(value)) {
        return FxIdDomainSettingsFxEventsClientPublicConfigToJSON(value as FxIdDomainSettingsFxEventsClientPublicConfig);
    }

    return {};
}

